export enum FeedbackType {
  error = 'error',
  noResults = 'no results',
  succes = 'succes',
  cat = 'cat',
}
